export default function BaseballIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <path d="M32 40 L54 18 A31 31 0 0 0 10 18 Z" fill="#3D8B45" />
      <path d="M32 40 L44 28 L32 16 L20 28 Z" fill="#C79764" />
      <rect x="9" y="47" width="40" height="7" rx="3.5" transform="rotate(-35 29 50)" fill="#C8955A" />
      <rect x="9" y="47" width="11" height="7" rx="3" transform="rotate(-35 29 50)" fill="#2F8BFF" />
      <circle cx="46" cy="44" r="13" fill="#FFFFFF" stroke="#D9DDE2" strokeWidth="1.5" />
      <path d="M38.5 34.5c3.5 2.5 5 6.5 4.2 10.8M53.5 53.5c-3.5-2.5-5-6.5-4.2-10.8" stroke="#E23B3B" strokeWidth="2.2" fill="none" strokeLinecap="round" strokeDasharray="2 1.6" />
      <path d="M20 9 l3 3 M44 9 l-3 3" stroke="#FF8A1F" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}
